var map = {
	"./1.mp4": 6230,
	"./10.mp4": 3412,
	"./12.mp4": 7574,
	"./14.mp4": 512,
	"./16.mp4": 9026,
	"./2.mp4": 7465,
	"./3.mp4": 3060,
	"./4.mp4": 6439,
	"./5.mp4": 8482,
	"./7.mp4": 9536,
	"./8.mp4": 7843,
	"./9.mp4": 1454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7752;